<div class="text-input-general-wrapper" tappable (click)="setFocus()">
  <div class="text-input-content-wrapper">
    <div class="icon-wrapper">
      <ion-icon name="alberta-dot"></ion-icon>
    </div>
    <div class="text-input">
      <div class="input-wrapper">
        <input [(ngModel)]="text" class="alb-input bold" #input />
        <div *ngIf="isMobile" class="scanButton" tappable (click)="scan()">
          <ion-icon slot="icon-only" name="barcode"></ion-icon>
        </div>
      </div>
      <div [ngClass]="node.mandatory ? 'title-wrapper required-star':'title-wrapper'">
        <div id="inputTitle">{{ node.title }} <span *ngIf="node.mandatory">*</span></div>
      </div>
    </div>
  </div>
</div>
